import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Text } from '@gympass/yoga';

import { setLanguage } from 'setup/translationsService';
import CopyBox from 'components/CopyBox';
import Template from 'components/Template';
import Loading from 'components/Loading';
import useDecodedPromoCode from 'hooks/useDecodedPromoCode';

import * as S from './styles';

export default function LandingPage() {
  const { t } = useTranslation();
  const { hash = '' } = useParams<{ hash: string }>();
  const { isDecoding, partner, locale, redirectUrl, redeemCode } =
    useDecodedPromoCode(hash);
  const [partnerLogo, setPartnerLogo] = useState(null);

  useEffect(() => {
    setLanguage(locale);

    if (partner) {
      const capitalizedPartnerName =
        partner[0].toUpperCase() + partner.slice(1);

      document.title = `${document.title} & ${capitalizedPartnerName}`;
    }
  }, [partner, locale]);

  useEffect(() => {
    if (!partner) return;
    import(`assets/images/${partner}.png`)
      .then(image => setPartnerLogo(image?.default))
      .catch(() => setPartnerLogo(null));
  }, [partner]);

  if (isDecoding) {
    return <Loading />;
  }

  return (
    <Template>
      <S.Container>
        {partnerLogo && (
          <img width={80} height={80} src={partnerLogo} alt={partner} />
        )}
        <S.Title bold>{t('title')}</S.Title>
        <S.Subtitle>{t(`${partner}.subtitle`)}</S.Subtitle>
        <CopyBox content={redeemCode} />
        <S.RedeemButtonWrapper>
          <Button href={redirectUrl}>{t(`${partner}.button-text`)}</Button>
        </S.RedeemButtonWrapper>
        <Text.Tiny light>{t(`${partner}.description`)}</Text.Tiny>
      </S.Container>
    </Template>
  );
}
